export const RETAILER_ADD_INFO_TO_CART = "RETAILER_ADD_INFO_TO_CART";
export const RETAILER_IDP_AUTHORIZE = "RETAILER_IDP_AUTHORIZE";
export const RETAILER_SET_PREPAID_WITH_STARTPAKKE = "RETAILER_SET_PREPAID_WITH_STARTPAKKE";

// Customer Info
export const RETAILER_LOOKUP_CUSTOMER_BY_PHONE_NUMBER = "RETAILER_LOOKUP_CUSTOMER_BY_PHONE_NUMBER";
export const RETAILER_SET_CUSTOMER_DETAILS = "RETAILER_SET_CUSTOMER_DETAILS";
export const RETAILER_SET_CUSTOMER_INFO_VALUE = "RETAILER_SET_CUSTOMER_INFO_VALUE";
export const RETAILER_RESET_CUSTOMER_INFO = "RETAILER_RESET_CUSTOMER_INFO";
export const RETAILER_PERFORM_CREDIT_CHECK = "RETAILER_PERFORM_CREDIT_CHECK";
export const RETAILER_SET_CONTACT_INFO = "RETAILER_SET_CONTACT_INFO";
export const RETAILER_SET_IDENTIFICATION = "RETAILER_SET_IDENTIFICATION";
export const RETAILER_GET_BANKID_RESULT = "RETAILER_GET_BANKID_RESULT";
export const RETAILER_CANCEL_BANKID_POLLING = "RETAILER_CANCEL_BANKID_POLLING";
export const RETAILER_SET_SELECTED_ACCOUNT_ID = "RETAILER_SET_SELECTED_ACCOUNT_ID";

// Phone Numbers
export const RETAILER_FETCH_AVAILABLE_PHONE_NUMBERS = "RETAILER_FETCH_AVAILABLE_PHONE_NUMBERS";
export const RETAILER_CHOOSE_PHONE_NUMBER_SWITCH_PANEL = "RETAILER_CHOOSE_PHONE_NUMBER_SWITCH_PANEL";
export const RETAILER_RESET_CURRENT_PHONE_NUMBER_CHECK_MESSAGES = "RETAILER_RESET_CURRENT_PHONE_NUMBER_CHECK_MESSAGES";
export const RETAILER_FETCH_PRICE_PLANS_FOR_EDIT = "RETAILER_FETCH_PRICE_PLANS_FOR_EDIT";

// Additional Products
export const RETAILER_FETCH_ADDITIONAL_SERVICES = "RETAILER_FETCH_ADDITIONAL_SERVICES";
export const RETAILER_FETCH_EXTRA_SIM_PRICES = "RETAILER_FETCH_EXTRA_SIM_PRICES";
export const RETAILER_ADD_SERVICES_FROM_RETAILER_FLOW = "RETAILER_ADD_SERVICES_FROM_RETAILER_FLOW";

// Subscription Steps
export const RETAILER_SET_SUBSCRIPTION_STEP = "RETAILER_SET_SUBSCRIPTION_STEP";
export const RETAILER_NEXT_SUBSCRIPTION_STEP = "RETAILER_NEXT_SUBSCRIPTION_STEP";
export const RETAILER_PREV_SUBSCRIPTION_STEP = "RETAILER_PREV_SUBSCRIPTION_STEP";
export const RETAILER_SET_COMPLETED_SUBSCRIPTION_STEPS = "RETAILER_SET_COMPLETED_SUBSCRIPTION_STEPS";
export const RETAILER_RESET_SUBSCRIPTION_STEPS = "RETAILER_RESET_SUBSCRIPTION_STEPS";
export const RETAILER_SET_IS_ADDING_SUBSCRIPTION = "RETAILER_SET_IS_ADDING_SUBSCRIPTION";

// Existing Subscription Change
export const RETAILER_SET_EXISTING_SUBSCRIPTION_FOR_CHANGE = "RETAILER_SET_EXISTING_SUBSCRIPTION_FOR_CHANGE";
export const RETAILER_CLEAR_EXISTING_SUBSCRIPTION_FOR_CHANGE = "RETAILER_CLEAR_EXISTING_SUBSCRIPTION_FOR_CHANGE";
export const RETAILER_SET_REOPEN_EXISTING_SUBSCRIPTION_PHONE = "RETAILER_SET_REOPEN_EXISTING_SUBSCRIPTION_PHONE";
export const RETAILER_CLEAR_REOPEN_EXISTING_SUBSCRIPTION_PHONE = "RETAILER_CLEAR_REOPEN_EXISTING_SUBSCRIPTION_PHONE";

// Order Submission
export const RETAILER_SUBMIT_ORDER = "RETAILER_SUBMIT_ORDER";

// Signature Methods
export const RETAILER_GET_SIGNATURE_METHODS = "RETAILER_GET_SIGNATURE_METHODS";
export const RETAILER_REQUEST_SIGN_DOCUMENT = "RETAILER_REQUEST_SIGN_DOCUMENT";
export const RETAILER_GET_SIGN_DOCUMENT_STATUS = "RETAILER_GET_SIGN_DOCUMENT_STATUS";
export const RETAILER_CONFIRM_MANUAL_SIGNATURE = "RETAILER_CONFIRM_MANUAL_SIGNATURE";

// Equipment
export const RETAILER_FETCH_PRODUCT_BY_EAN = "RETAILER_FETCH_PRODUCT_BY_EAN";
export const RETAILER_SET_SELECTED_EAN = "RETAILER_SET_SELECTED_EAN";
export const RETAILER_ADD_EXTERNAL_HARDWARE = "RETAILER_ADD_EXTERNAL_HARDWARE";

// Draft Orders
export const RETAILER_FETCH_DRAFT_ORDERS = "RETAILER_FETCH_DRAFT_ORDERS";

// Cancel and Restart
export const RETAILER_CANCEL_AND_RESTART = "RETAILER_CANCEL_AND_RESTART";
export const RETAILER_CANCEL_CONFLICTING_ORDER = "RETAILER_CANCEL_CONFLICTING_ORDER";
export const RETAILER_UPDATE_SUBSCRIPTION_PRODUCT_USER_EMAIL = "RETAILER_UPDATE_SUBSCRIPTION_PRODUCT_USER_EMAIL";

// Sales Agent
export const RETAILER_UPDATE_SELECTED_AGENT = "RETAILER_UPDATE_SELECTED_AGENT";

// FWA
export const RETAILER_FWA_CHECK_COVERAGE = "RETAILER_FWA_CHECK_COVERAGE";
export const RETAILER_FWA_SET_SELECTED_PACKAGE = "RETAILER_FWA_SET_SELECTED_PACKAGE";
export const RETAILER_FWA_SET_TRADLOS_TAB_ACTIVE = "RETAILER_FWA_SET_TRADLOS_TAB_ACTIVE";
